import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
} from '@mui/material';

const SceneActionsDialog = ({
  open,
  onClose,
  sceneTitle,
  canMergeIntoPrevious,
  onMergeIntoPrevious,
  onDeleteScene,
}) => {
  const body = canMergeIntoPrevious
    ? 'Delete this scene, or merge its content into the scene above.'
    : 'Delete this scene from the manuscript.';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Scene</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            {sceneTitle || 'Untitled scene'}
          </Typography>
          <Typography variant="body2">{body}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ flexWrap: 'wrap', gap: 1, px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        {canMergeIntoPrevious && (
          <Button onClick={onMergeIntoPrevious} color="primary" variant="outlined">
            Merge into previous
          </Button>
        )}
        <Button onClick={onDeleteScene} color="error" variant="contained">
          Delete scene
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SceneActionsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sceneTitle: PropTypes.string,
  canMergeIntoPrevious: PropTypes.bool.isRequired,
  onMergeIntoPrevious: PropTypes.func.isRequired,
  onDeleteScene: PropTypes.func.isRequired,
};

SceneActionsDialog.defaultProps = {
  sceneTitle: '',
};

export default SceneActionsDialog;
